/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { TeamMeetingActionItem } from "./TeamMeetingActionItem";
import {
  TeamMeetingActionItemFromJSON,
  TeamMeetingActionItemFromJSONTyped,
  TeamMeetingActionItemToJSON,
  TeamMeetingActionItemToJSONTyped,
} from "./TeamMeetingActionItem";
import type { MeetingParticipant } from "./MeetingParticipant";
import {
  MeetingParticipantFromJSON,
  MeetingParticipantFromJSONTyped,
  MeetingParticipantToJSON,
  MeetingParticipantToJSONTyped,
} from "./MeetingParticipant";

/**
 *
 * @export
 * @interface TeamMeetingPreview
 */
export interface TeamMeetingPreview {
  /**
   *
   * @type {string}
   * @memberof TeamMeetingPreview
   */
  jamieMeetingId: string;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingPreview
   */
  jamieUrl: string;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingPreview
   */
  title?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof TeamMeetingPreview
   */
  meetingDate?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingPreview
   */
  summaryShort?: string | null;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingPreview
   */
  summaryMarkdown?: string | null;
  /**
   *
   * @type {Array<MeetingParticipant>}
   * @memberof TeamMeetingPreview
   */
  participants: Array<MeetingParticipant>;
  /**
   *
   * @type {Array<TeamMeetingActionItem>}
   * @memberof TeamMeetingPreview
   */
  actionItems: Array<TeamMeetingActionItem>;
}

/**
 * Check if a given object implements the TeamMeetingPreview interface.
 */
export function instanceOfTeamMeetingPreview(
  value: object,
): value is TeamMeetingPreview {
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  if (!("jamieUrl" in value) || value["jamieUrl"] === undefined) return false;
  if (!("participants" in value) || value["participants"] === undefined)
    return false;
  if (!("actionItems" in value) || value["actionItems"] === undefined)
    return false;
  return true;
}

export function TeamMeetingPreviewFromJSON(json: any): TeamMeetingPreview {
  return TeamMeetingPreviewFromJSONTyped(json, false);
}

export function TeamMeetingPreviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TeamMeetingPreview {
  if (json == null) {
    return json;
  }
  return {
    jamieMeetingId: json["jamieMeetingId"],
    jamieUrl: json["jamieUrl"],
    title: json["title"] == null ? undefined : json["title"],
    meetingDate: json["meetingDate"] == null ? undefined : json["meetingDate"],
    summaryShort:
      json["summaryShort"] == null ? undefined : json["summaryShort"],
    summaryMarkdown:
      json["summaryMarkdown"] == null ? undefined : json["summaryMarkdown"],
    participants: (json["participants"] as Array<any>).map(
      MeetingParticipantFromJSON,
    ),
    actionItems: (json["actionItems"] as Array<any>).map(
      TeamMeetingActionItemFromJSON,
    ),
  };
}

export function TeamMeetingPreviewToJSON(json: any): TeamMeetingPreview {
  return TeamMeetingPreviewToJSONTyped(json, false);
}

export function TeamMeetingPreviewToJSONTyped(
  value?: TeamMeetingPreview | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    jamieMeetingId: value["jamieMeetingId"],
    jamieUrl: value["jamieUrl"],
    title: value["title"],
    meetingDate: value["meetingDate"],
    summaryShort: value["summaryShort"],
    summaryMarkdown: value["summaryMarkdown"],
    participants: (value["participants"] as Array<any>).map(
      MeetingParticipantToJSON,
    ),
    actionItems: (value["actionItems"] as Array<any>).map(
      TeamMeetingActionItemToJSON,
    ),
  };
}
